module.exports = __webpack_public_path__ + "img/appstore.9fa0fc73.svg";